import { Route, Routes } from 'react-router-dom';
import { Layout } from './Layout.js';
import { HomePage } from './pages/Home.js';

export function App() {
  return (
    <Routes>
      <Route element={<Layout appName="Bindery" tagline="The workshop where the archive is bound." />}>
        <Route index element={<HomePage />} />
      </Route>
    </Routes>
  );
}
